import React from 'react'
import {
  OreButton,
  OreMessageBar,
  OreModal,
  OreModalBox,
  OreModalBoxBody,
  OreModalBoxFooter,
  OreStack,
  OreText,
  SvgWarning,
} from '@edenredespana/oreneta'
import { Trans, useTranslation } from 'react-i18next'
import { LoginTranslation } from '../accountTranslation'
import { SignUpTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

interface CannotRecoverProps {
  isErrorMessageOpen: boolean
  setOpen: (open: boolean) => void
}

export const IndentifyAffiliateErrorModal: React.FC<CannotRecoverProps> = ({
  isErrorMessageOpen,
  setOpen,
}) => {
  const { t } = useTranslation()

  return (
    <OreModal open={isErrorMessageOpen} handleOnClose={() => setOpen(false)}>
      <OreModalBox size="extralarge" handleOnClose={() => setOpen(false)}>
        <span className="mt-18px" />
        <OreModalBoxBody>
          <OreMessageBar color="error" icon={false}>
            <OreStack direction="row" placeItems="center">
              <SvgWarning />
              {t(LoginTranslation.recovery.errorModal.alert)}
            </OreStack>
          </OreMessageBar>
          <OreStack space="large">
            <OreText size="text-md" tone="neutral-600">
              <Trans t={t} components={
                [
                  <a href={`mailto:${import.meta.env.VITE_CONTACT_EMAIL}?subject=${t(LoginTranslation.navbar.mailtoButton.subject)}`} />
                ]
              }>
                {t(LoginTranslation.recovery.errorModal.subtitle, {
                  CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL,
                })}
              </Trans>
            </OreText>
          </OreStack>
        </OreModalBoxBody>
        <OreModalBoxFooter>
          <OreButton onClick={() => setOpen(false)} category="primary">
            {t(formTranslation.common.buttons.understood)}
          </OreButton>
        </OreModalBoxFooter>
      </OreModalBox>
    </OreModal>
  )
}
